import { navigate } from '@reach/router'
import { URLS } from '../../constants'
import { URLS_APP } from '../../config'
import { temAssinaturaClubeNormal, temBooksterNoToken } from '../helpers/helpersToken'

export const navigateParaHome = ( redirectTo ) => {
  let homeUrl = ''
  if ( URLS_APP.BASE_PATH ) {
    homeUrl = `${homeUrl}${URLS_APP.BASE_PATH}`
  }

  homeUrl = `${homeUrl}${URLS.HOME}`

  if ( redirectTo ) {
    homeUrl = `${homeUrl}?redirectTo=${redirectTo}`
  }

  navigate( homeUrl )
}

export const navigateParaBookster = () => {
  let booksterUrl = ''
  if ( URLS_APP.BASE_PATH ) {
    booksterUrl = `${booksterUrl}${URLS_APP.BASE_PATH}`
  }

  booksterUrl = `${booksterUrl}/${URLS.BOOKSTER}`

  navigate( booksterUrl )
}

export const navigateParaDestinoPosLogin = redirectTo => {
  if ( redirectTo && redirectTo.split( '/' ).includes( URLS.BOOKSTER ) ) {
    navigateParaBookster()
    return
  }

  navigateParaHome( redirectTo )
}

export const navigateParaAdaComRedirect = redirectTo => {
  const urlBookster = Boolean( redirectTo ) && redirectTo.split( '/' ).includes( URLS.BOOKSTER )

  if ( temBooksterNoToken() && ( urlBookster || !temAssinaturaClubeNormal() ) ) {
    navigateParaBookster()
    return
  }

  navigateParaHome()
}
